import { render, staticRenderFns } from "./BeneficioCodigos.vue?vue&type=template&id=2d080690&scoped=true&"
import script from "./BeneficioCodigos.vue?vue&type=script&lang=js&"
export * from "./BeneficioCodigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d080690",
  null
  
)

export default component.exports